import {AuthorizedActions} from "@/authorization";
import {hasAccessRights} from "@/authorization/AuthorizationService";

export const getAccessRights = (authorizedActions: AuthorizedActions) => {

    const hasReadRights = authorizedActions.read ? hasAccessRights(authorizedActions.read) : false;
    const hasEditRights = authorizedActions.edit ? hasAccessRights(authorizedActions.edit) : false;
    const hasDownloadRights = authorizedActions.download ? hasAccessRights(authorizedActions.download) : false;

    return {
      hasReadRights,
      hasEditRights,
      hasDownloadRights,
    }
}
